<template>
    <medium-dialog
        v-model="dialog"
        :title="title"
        noOkButton
        noActivator
        loading="period"
        scrollable
    >
        <div v-if="user">
            <user-information-table :user="user"></user-information-table>

            <user-enrollments
                :user="user"
                class="mt-4"
                ref="userEnrollments"
            ></user-enrollments>
        </div>
    </medium-dialog>
</template>

<script>
import MediumDialog from '@/components/dialog/MediumDialog'
import UserInformationTable from './UserInformationTable.vue'
import UserEnrollments from './UserEnrollments.vue'

export default {
    components: {
        MediumDialog,
        UserInformationTable,
        UserEnrollments,
    },

    data: () => ({
        user: null,
        dialog: false,
    }),

    watch: {
        dialog() {
            if (! this.dialog) {
                this.$nextTick(() => this.$refs.userEnrollments.reset())
            }
        }
    },

    computed: {
        title() {
            return this.user ? this.user.name : null
        },
    },

    methods: {
        show(user) {
            this.user = user
            this.dialog = true

            this.$nextTick(() => this.$refs.userEnrollments.refresh())
        }
    }
}
</script>
